import axios from 'axios';
import { apiBaseUrl } from '../configs/app';
import loginService from './loginService';
import { ShippingBooking, ShippingBookingFilter } from '../types/shipping-booking.type';

export async function createShippingBooking(data: Partial<ShippingBooking>): Promise<{ message: string; booking: ShippingBooking }> {
    const token = loginService.currentUser?.token;
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.post(`${apiBaseUrl}shipping-bookings`, data, { headers });
    return response.data;
}

export async function fetchShippingBooking(id: string | number): Promise<ShippingBooking> {
    const response = await axios.get(`${apiBaseUrl}shipping-bookings/${id}`);
    return response.data;
}

export async function fetchUserShippingBookings(page = 1) {
    return loginService.privateGetApiCall(`${apiBaseUrl}user/shipping-bookings`, { page });
}

export async function fetchAdminShippingBookings(filter: ShippingBookingFilter = {}) {
    const params: Record<string, any> = {
        page: filter.page || 1,
    };
    if (filter.search) params.search = filter.search;
    if (filter.status && filter.status !== 'all') params.status = filter.status;
    if (filter.method && filter.method !== 'all') params.method = filter.method;

    return loginService.privateGetApiCall(`${apiBaseUrl}admin/shipping-bookings`, params);
}

export async function updateAdminShippingBooking(id: number | string, data: Partial<ShippingBooking>) {
    return loginService.privateApiCall(`${apiBaseUrl}admin/shipping-bookings/${id}/update`, data);
}

export async function deleteAdminShippingBooking(id: number | string) {
    const token = loginService.currentUser?.token;
    const response = await axios.delete(`${apiBaseUrl}admin/shipping-bookings/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
        }
    });
    return response.data;
}

